import moment from "moment";
import "moment/locale/es";
import {cuentaMask, dineroDisabledMask} from '../Components/Items'

moment.locale("es");

// Columnas de la tabla. Sin "Mostrar vendedor" ni "Desglosar impuestos" son las nueve de
// siempre con sus mismos anchos; con cualquiera de las dos la hoja va horizontal y los
// anchos se reparten por peso. Titulos, renglones, total y widths salen de esta misma lista
// para que nunca haya una fila con mas celdas que widths.
const columnasReporteIngresos = (values) => {
    const mostrarVendedor = values.mostrarVendedor === true
    const desglosarImpuestos = values.desglosarImpuestos === true
    const extendido = mostrarVendedor || desglosarImpuestos
    return [
        {titulo: 'Banco', campo: 'banco', alineacion: 'left', ancho: '10%', peso: 8},
        {titulo: 'Fecha', campo: 'fechaPago', alineacion: 'center', ancho: '10%', peso: 6},
        {titulo: 'Cliente', campo: 'cliente', alineacion: 'left', ancho: '20%', peso: 12},
        ...(mostrarVendedor ? [{titulo: 'Vendedor', campo: 'vendedor', alineacion: 'left', peso: 10}] : []),
        {titulo: 'Venta', campo: 'venta', alineacion: 'left', ancho: '10%', peso: 7},
        ...(extendido ? [{titulo: 'Origen', campo: 'origen', alineacion: 'left', peso: 6}] : []),
        {titulo: 'Proyecto', campo: 'proyecto', alineacion: 'left', ancho: '10%', peso: 6},
        {titulo: 'Forma De Pago', campo: 'formaDePago', alineacion: 'left', ancho: '12%', peso: 8},
        {titulo: 'Moneda', campo: 'moneda', alineacion: 'left', ancho: '8%', peso: 4},
        ...(desglosarImpuestos ? [
            {titulo: 'Subtotal', campo: 'subtotal', dinero: true, peso: 8},
            {titulo: 'IVA', campo: 'iva', dinero: true, peso: 8},
            ...(values.hayOtrosImpuestos ? [{titulo: 'Otros Imp.', campo: 'otrosImpuestos', dinero: true, peso: 8}] : []),
            {titulo: 'Retenciones', campo: 'retenciones', dinero: true, peso: 8},
        ] : []),
        {titulo: desglosarImpuestos ? 'Total' : 'Monto', campo: 'monto', dinero: true, ancho: '10%', peso: 8},
        {titulo: 'Referencia', campo: 'referencia', alineacion: 'left', ancho: '10%', peso: 6},
    ]
}

// Arreglo nuevo en cada llamada: pdfMake muta los widths que recibe
const anchosReporteIngresos = (columnas, extendido) => {
    if (!extendido) return columnas.map((columna) => columna.ancho)
    const pesoTotal = columnas.reduce((acc, columna) => acc + columna.peso, 0)
    return columnas.map((columna) => (Math.floor((columna.peso / pesoTotal) * 10000) / 100) + '%')
}

const textoDinero = (valor) => (valor === null || valor === undefined ? '' : dineroDisabledMask(valor))

const reporteDeIngresosPdf = (values) => {
    const empresa = values.empresa
    const logoBiwo = values.logoBiwo;
    const extendido = values.mostrarVendedor === true || values.desglosarImpuestos === true
    const columnas = columnasReporteIngresos(values)
    const estiloTexto = extendido ? 'textoTablaChica' : 'textoTabla'
    let filtrados = []
    if(values.bancos !== 0 && values.bancos && values.bancos.length > 0){
        let textoFiltrado = ''
        values.bancos.map((valueBanco) => {
            textoFiltrado += `${valueBanco.nombre}\n`
            return null
        })
        filtrados.push([
            {text: 'Bancos:', style: 'subheader'},
            
            {text: textoFiltrado, style: 'textoChico'}
          ])
    }

    if(values.filtrarProyecto === 1){
        let textoFiltrado = ''
        values.proyectos.map((valueProyectos) => {
            textoFiltrado += `${valueProyectos.nombre}\n`
            return null
        })
        filtrados.push([
            {text: 'Proyectos:', style: 'subheader'},
            
            {text: textoFiltrado, style: 'textoChico'}
          ])
    }

    if(values.filtrarProyecto === 2){
        filtrados.push([
            {text: 'Unidad de Negocio:', style: 'subheader'},
            
            {text: `${cuentaMask(
                values.unidadDeNegocio.nivel1 + values.unidadDeNegocio.nivel2 + values.unidadDeNegocio.nivel3 + values.unidadDeNegocio.nivel4 +values.unidadDeNegocio.nivel5
              ) +
                " - " +
                values.unidadDeNegocio.nombre}`, style: 'textoChico'}
          ])
    }

    if(values.vendedores && values.vendedores.length > 0){
        let textoFiltrado = ''
        values.vendedores.map((valueVendedor) => {
            textoFiltrado += `${[valueVendedor.nombre, valueVendedor.apellidoPaterno, valueVendedor.apellidoMaterno].filter(Boolean).join(' ')}\n`
            return null
        })
        filtrados.push([
            {text: 'Vendedores:', style: 'subheader'},

            {text: textoFiltrado, style: 'textoChico'}
          ])
    }

    let pagos = []

    for(const valuePago of values.pagos){
        pagos.push(columnas.map((columna) => columna.dinero
            ? {text: textoDinero(valuePago[columna.campo]), style: estiloTexto, alignment: 'right'}
            : {text: valuePago[columna.campo], style: estiloTexto, alignment: columna.alineacion}
        ))
    }

    const sumaColumna = (campo) => values.pagos.reduce((acc, val) => acc + parseFloat(val[campo] || 0), 0);

    pagos.push(columnas.map((columna, index) => {
        if (index === 0) {
            return { text: 'TOTAL:', style: 'tituloTabla', alignment: 'left', border: [true, true, true, true], fillColor: '#cccccc' }
        }
        if (columna.dinero) {
            return { text: dineroDisabledMask(sumaColumna(columna.campo)), style: 'textoTotal', alignment: 'right', border: [true, true, true, true], fillColor: '#cccccc' }
        }
        return { text: '', style: estiloTexto, border: [false, true, index === columnas.length - 1, true], fillColor: '#cccccc' }
    }));

    if(filtrados.length === 0){
        filtrados.push([
            {text: 'No tiene filtrados adicionales', style: 'subheader'},

            {text: '', style: 'textoChico'}
      ] )
    }

    var dd = {
        footer: {
            image: 'logoBiwo', alignment: 'center', width: 80
        },
          content: [
              {
                  style: 'tableExample',
                  table: {
                      widths: [ '18%', '52%', '30%'],
                      layout: {
                          defaultBorder: false,
                      },
                      body: [
                          [
                              {
      //							rowSpan: 3,
                                  border: [false, false, false, false],
                                  image: 'logo',
                                  fit: [80, 80] 
                                  //text: 'rowSpan: 3\n\nborder:\n[true, true, true, true]'
                              },
                              {
                              //	rowSpan: 2,
                                  border: [false, false, false, false],
                                  table: {
                                      headerRows: 1,
                                      widths: ['100%'],
                                  
                                      body: [
                                        [
                                            { 
                                            text: empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : empresa.nombre+' '+empresa.apellidoPaterno+' '+empresa.apellidoMaterno), 
                                            style: "tableHeader" 
                                            }
                                        ],
                                        [
                                          {
                                            text: "R.F.C: "+empresa.rfc,
                                            style: "textoChico",
                                            alignment: "center",
                                          },
                                        ],
                                        [
                                            {
                                              text: empresa.calle+' '+
                                                    empresa.numeroCalle+' '+
                                                    (empresa.numeroInterior ? empresa.numeroInterior : '')
                                              ,
                                              style: "textoChico",
                                              alignment: "center",
                                            },
                                          ],
                                        [
                                            {
                                              text: empresa.colonia.tipoAsentamiento+' '+
                                              empresa.colonia.nombre+' C.P. '+
                                              empresa.colonia.cp+' '+
                                              empresa.municipio.nombre+' '+
                                              empresa.estado.abreviatura+' '+
                                              empresa.pais.abreviatura+' '
                                              ,
                                              style: "textoChico",
                                              alignment: "center",
                                            },
                                          ],
                                          [{text: 'REPORTE DE INGRESOS', style: 'tableHeader'}],
                                      ]
                                  },
                                  layout: 'noBorders'
                              },
                              {
                                  border: [false, false, false, false],
                                      table: {
                                      headerRows: 1,
                                      widths: ['100%'],
                                  
                                      body: [
                                          [{text: 'Fecha Inicial:', style: 'subheader', alignment: 'center'}],
                                          [{text: moment(values.fechaInicial).locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                          [{text: 'Fecha Final:', style: 'subheader', alignment: 'center'}],
                                          [{text: moment(values.fechaFinal).locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                          [{text: 'Fecha de Impresión:', style: 'subheader', alignment: 'center'}],
                                          [{text: moment().locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                      ]
                                  },
                                  layout: 'noBorders'
                              },
                          ]
      
                      ]
                  },
              },
              {text: 'Datos de filtrado:'},
              {
                  style: 'tableExample',
                  table: {
                      widths: ['20%', '80%'],
                      layout: {
                                          defaultBorder: false,
                                      },
                      
                      body: filtrados,
                  },
                              layout: {
                      hLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.body.length) ? 1 : 1;
                      },
                      vLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                      },
                      hLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      vLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      hLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.body.length) {
                              return null;
                          }
                          return {dash: {length: 2, space: 1}};
                      },
                      vLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.widths.length) {
                              return null;
                          }
                          return {dash: {length: 2}};
                      },
                      // paddingLeft: function(i, node) { return 4; },
                      // paddingRight: function(i, node) { return 4; },
                      // paddingTop: function(i, node) { return 2; },
                      // paddingBottom: function(i, node) { return 2; },
                      // fillColor: function (i, node) { return null; }
                  }
                  
              },
              
              {
                  style: 'tableExample',
                  table: {
                      widths: anchosReporteIngresos(columnas, extendido),
                      layout: {
                          defaultBorder: true,
                      },
                      body: [
                          columnas.map((columna) => ({text: columna.titulo, style: 'tituloTabla'})),
                          ...pagos
                      ]
                  },
                  layout: {
                      fillColor: (rowIndex, node, columnIndex) => {
                          return rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff";
                      },
                      hLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.body.length) ? 1 : 1;
                      },
                      vLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                      },
                      hLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      vLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      hLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.body.length) {
                              return null;
                          }
                          return {dash: {length: 2, space: 1}};
                      },
                      vLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.widths.length) {
                              return null;
                          }
                          return {dash: {length: 2}};
                      },
                      // paddingLeft: function(i, node) { return 4; },
                      // paddingRight: function(i, node) { return 4; },
                      // paddingTop: function(i, node) { return 2; },
                      // paddingBottom: function(i, node) { return 2; },
                      // fillColor: function (i, node) { return null; }
                  }
              },
              
          ],
          images: {
            logo: empresa.logo.base64Completa,
            logoBiwo: logoBiwo.base64Completa,
          },
          styles: {
              header: {
                  fontSize: 9,
                  bold: true,
              },
              subheader: {
                  fontSize: 8,
                  bold: true,
              },
              tableExample: {
                  margin: [0, 5, 0, 5]
              },
              tablaSinMargen: {
                  margin: [0, 0, 0, 0]
              },
              tableHeader: {
                  bold: true,
                  fontSize: 12,
                  color: 'black',
                  alignment: 'center'
              },
              textoChico:{
                  fontSize: 8
              },
              tituloTabla:{
                  fontSize: 8,
                  bold: true, 
                  fillColor: '#cccccc', 
                  style: 'subheader', 
                  alignment: 'center',
                  border: true
              },
              textoTabla: {
                  fontSize: 8,
                  italics: false
              },
              textoTotal: {
                fontSize: 7,
                italics: false
            },
              ...(extendido ? {
                  textoTablaChica: {
                      fontSize: 7,
                      italics: false
                  },
              } : {}),
          },
          pageSize: 'LETTER',
          ...(extendido ? {pageOrientation: 'landscape'} : {}),
          pageMargins: [ 20, 20, 20, 60 ],
    }
  return dd;
};


export default reporteDeIngresosPdf;
